import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import MembersRepository from 'services/repositories/MembersRepository';
import Col from '../../UI/Layout/Col';
import Container from '../../UI/Layout/Container';

function TravefyAuthorizationCallback()
{
    const [status, setStatus] = useState(null);
    const [message, setMessage] = useState('Loading...');
    const location = useLocation();
    const { driver } = useParams();

    useEffect(() =>
    {
        const queryParams = new URLSearchParams(location.search);
        const authorizationCode = queryParams.get('code');


        if (!authorizationCode)
        {
            setStatus('error');
            setMessage('No authorization code provided.');
            return;
        }

        const fetchUserData = async () =>
        {
            try
            {
                const repository = new MembersRepository();
                const result = await repository.saveAuthorizationCode(
                    authorizationCode,
                    driver
                );
                if (result.status === 'error')
                {
                    throw new Error(result.messages[0]);
                }

                // Handle the response as needed, e.g., save user data, update UI, etc.
                setStatus('success');
                setMessage(
                    'Your account has been successfully connected to Travefy.',
                );
            }
            catch (error)
            {
                setStatus('error');
                setMessage('Please try again or contact support.');
            }
        };

        fetchUserData();
    }, []);

    return (
        <Container className="tw-flex tw-w-full tw-min-h-screen">
            <Col className="tw-self-center tw-text-center tw-p-3 tw-text-gray-500">
                {status != null && (
                    <h1
                        className={`tw-text-3xl tw-mb-5 ${
                            status !== 'success' ? 'tw-text-red-500' : ''
                        }`}
                    >
                        Authorization{' '}
                        {status === 'success' ? 'Successful' : 'Failed'}
                    </h1>
                )}
                <p>{message}</p>
                {status === 'success' && (
                    <div className="tw-py-5">
                        <p>
                            Your account has been connected to your Travefy
                            account. You can now send trips to your Travefy
                            account.
                        </p>
                    </div>
                )}
                {status === 'error' && (
                    <div className="tw-py-5">
                        <p>
                            Go to your Profile section to try to authorize
                            again.
                        </p>
                        <p>
                            If you need assistance, please contact support at{' '}
                            <a href="mailto:operations@ultimatejetvacations.com?subject=Travefy%20Auth%20Support">
                                operations@ultimatejetvacations.com
                            </a>
                        </p>
                    </div>
                )}
            </Col>
        </Container>
    );
}

export default TravefyAuthorizationCallback;
